"use client";

import { cn } from "@/lib/utils";

type ActionButtonProps = {
  variant?: "primary" | "secondary";
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const ActionButton = ({
  variant = "primary",
  className,
  type = "button",
  ...props
}: ActionButtonProps) => {
  return (
    <button
      type={type}
      className={cn(
        "h-14 w-full rounded-full text-lg font-semibold transition-colors duration-300 hover:cursor-pointer disabled:cursor-not-allowed disabled:bg-[#DADBDD] disabled:text-[#898D91] disabled:hover:bg-[#DADBDD]",
        variant === "primary"
          ? "bg-[#3BDAFF] text-[#1C1E21] hover:bg-[#33C2E5] active:bg-[#2DB2D6]"
          : "border border-[#EDEEEE] bg-white text-[#1C1E21] hover:bg-[#F8F9FA]",
        className,
      )}
      {...props}
    />
  );
};
